import { ClientsPage } from './pages';

export const clientsRoutes = [
  {
    path: 'clients',
    component: ClientsPage,
    requiredPermission: 'clients.view',
  },
];
